// ─── Chemin d'une discussion : le porteur est dans le CHEMIN ──────
// Réécrit le 09/08 après un incident de production : la messagerie renvoyait
// « Missing or insufficient permissions » sur TOUTES les listes.
//
// CE QUI S'EST PASSÉ. Les discussions vivaient dans une collection PLATE, avec
// un champ `cible` d'où la règle tirait le calendrier à contrôler :
//   get(/calendriers/$(resource.data.cibleId))
// Or Firestore refuse une règle de LISTE dont l'accès document dépend du
// CONTENU de chaque candidat — il ne peut pas aller chercher un document
// différent par document évalué. Vérifié à trois témoins sur les émulateurs :
//   • sous-collection, id venant du CHEMIN  → liste AUTORISÉE
//   • collection plate, id venant du DOCUMENT → liste REFUSÉE
//   • collection plate, id EN DUR            → liste autorisée
// La lecture unitaire, elle, passait dans les trois cas : c'est pourquoi le
// défaut n'apparaissait qu'à l'usage réel, et pas à la compilation des règles.
//
// LA CORRECTION. Le porteur passe dans le CHEMIN :
//   calendriers/{calId}/discussions/{discId}/messages/{msgId}
//   espaces/{espId}/discussions/{discId}/messages/{msgId}
// La règle connaît alors sa cible AVANT de lire quoi que ce soit, et n'a plus
// besoin d'un `get()` dépendant du document. Le cloisonnement redevient réel :
// on ne peut pas lister sous un calendrier qu'on ne voit pas — le chemin
// lui-même est refusé, pas seulement son contenu.
//
// Module PUR : aucun import Firestore, donc testable.

// Collection porteuse d'un type d'élément. Le modèle reste GÉNÉRAL (choix de
// Cédric) : l'espace ET ses éléments peuvent porter des discussions.
export const COLLECTION_PORTEUR = {
  espace: 'espaces',
  calendrier: 'calendriers',
  inventaire: 'inventaires',
  plan: 'plans',
};

export const TYPES_PORTEUR = Object.keys(COLLECTION_PORTEUR);

// « calendrier:abc » → ['calendriers', 'abc', 'discussions']
// Renvoie null si la clé est mal formée ou d'un type inconnu — un appelant qui
// reçoit null doit refuser l'opération plutôt que deviner un chemin.
export function cheminDiscussions(cle) {
  const i = String(cle || '').indexOf(':');
  if (i <= 0 || i === String(cle).length - 1) return null;
  const type = String(cle).slice(0, i);
  const id = String(cle).slice(i + 1);
  const col = COLLECTION_PORTEUR[type];
  return col ? [col, id, 'discussions'] : null;
}

export function cheminDiscussion(cle, discId) {
  const base = cheminDiscussions(cle);
  return base && discId ? [...base, discId] : null;
}

export function cheminMessages(cle, discId) {
  const d = cheminDiscussion(cle, discId);
  return d ? [...d, 'messages'] : null;
}

export function cheminMessage(cle, discId, msgId) {
  const m = cheminMessages(cle, discId);
  return m && msgId ? [...m, msgId] : null;
}

// Chemin → clé de porteur. Sert au sens INVERSE : retrouver la cible d'un
// document qu'on tient déjà, sans la stocker en double dans le document (une
// donnée dupliquée finit toujours par diverger de son chemin).
export function cleDepuisChemin(segments) {
  const l = segments || [];
  const i = l.indexOf('discussions');
  if (i < 2) return null;
  const type = Object.keys(COLLECTION_PORTEUR).find(k => COLLECTION_PORTEUR[k] === l[i - 2]);
  return type ? `${type}:${l[i - 1]}` : null;
}

// Id DÉTERMINISTE de la Générale — inchangé (`gen_<id du porteur>`) : deux
// appareils qui la créent au même instant écrivent le MÊME document, et les
// discussions déjà nommées ainsi (dont `gen_ivv`) gardent leur identité.
export function idGeneraleDe(cle) {
  const i = String(cle || '').indexOf(':');
  return i > 0 ? `gen_${String(cle).slice(i + 1)}` : null;
}
